<div align="center">
    <form class="form">

        <img srcset="assets/images/conveyor_1_v1.gif 1200w" sizes="(max-height: 400px) 280px,
                        600px" src="assets/images/conveyor_1_v1.gif" />

    </form>
</div>